module.exports = __webpack_public_path__ + "img/$.dedda952.svg";